// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { success } from 'react-notification-system-redux'
import { loadingToggler } from 'redux/modules/loading'
import { initialize } from 'redux-form'
import { putProjectInterferenceParameters } from 'helpers/api'
import { setParametersStatuses } from 'redux/modules/interferenceAnalysis'
import { AFS_PARAMETERS } from 'redux/modules/interferenceAnalysis/constants'

import {
  parseInterferenceParameters,
  prepInterferenceParametersForAPI,
} from 'redux/modules/interferenceAnalysis/helpers'

// NOTE - exceptions are thrown to the caller and not passed to redux-form.
const submitInterferenceParameters = formValues => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        interferenceAnalysis,
        projectSummary,
      } = getState()
      const projectId = projectSummary.get('projectId')
      const unitType = projectSummary.get('unitType')

      const parameters = prepInterferenceParametersForAPI(formValues)
      const propagationModels = interferenceAnalysis.get('propagationModels')

      const { entities } = await putProjectInterferenceParameters(projectId, parameters)
      const initialParameterValues = parseInterferenceParameters(entities, unitType, propagationModels)

      // NOTE - this line will need to come AFTER the request for Run Analysis so we can properly
      // capture when jobs were requested through that.
      const bands = await dispatch(setParametersStatuses(initialParameterValues))
      await dispatch(initialize(AFS_PARAMETERS, { bands }))

      dispatch(success({
        uid: Date.now(),
        title: 'Success!',
        position: 'tr',
        autoDismiss: 3,
        children: 'Successfully Updated Analysis Parameters.',
      }))
    })
  )
)

export default submitInterferenceParameters
